import { render, staticRenderFns } from "./AprovadoresTabela.vue?vue&type=template&id=34dae5af&scoped=true"
import script from "./AprovadoresTabela.vue?vue&type=script&setup=true&lang=js"
export * from "./AprovadoresTabela.vue?vue&type=script&setup=true&lang=js"
import style0 from "./AprovadoresTabela.vue?vue&type=style&index=0&id=34dae5af&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34dae5af",
  null
  
)

export default component.exports